export const resolveParams = ({path, params}) => {
  let str = path;
  Object.keys(params || {}).forEach(param => {
    const re = new RegExp(`:${param}\\??`);
    str = str.replace(re, params[param]);
  });
  return str;
};



// WEBPACK FOOTER //
// ./src/module/RoutingUtils.js